module.exports = __webpack_public_path__ + "static/img/thumb_60.032c560.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_60.jpg
// module id = 66wB
// module chunks = 0